import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { MEXICO_PROVINCES } from "_common/regions/regions";

export const pueblaAttraction: TAttraction[] = [
    {
        name: "Hermanos Serdán International Airport (PBC)",
        type: ATTRACTION_TYPE.AIRPORT,
        coordinates: { lat: 19.163838, lng: -98.3786732 },
        region: MEXICO_PROVINCES.STATE_OF_PUEBLA,
    },
];
